import { render, staticRenderFns } from "./ScholarFooter.vue?vue&type=template&id=1fb72eee&"
import script from "./ScholarFooter.vue?vue&type=script&lang=js&"
export * from "./ScholarFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports